/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Playing_Title_LeadInputs */

const en_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitive achievements &`)
};

const es_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros competitivos y`)
};

const de_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turniererfolge &`)
};

const zh_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比赛成就与`)
};

const ar_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنجازات تنافسية و`)
};

const fr_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palmarès en compétition et`)
};

const vi_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích thi đấu và`)
};

const sw_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafanikio ya mashindano na`)
};

const th_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จในการแข่งขันและ`)
};

const bs_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takmičarska dostignuća i`)
};

const ja_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競技成績と`)
};

const ko_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대회 성적 &`)
};

const pt_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas competitivas e`)
};

const it_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati agonistici e`)
};

const sv_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tävlingsmeriter och`)
};

const nl_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijdprestaties &`)
};

const da_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turneringsresultater og`)
};

const nb_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turneringsmeritter og`)
};

const fi_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilpailusaavutukset ja`)
};

const pl_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięcia turniejowe i`)
};

const ru_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спортивные достижения и`)
};

const tr_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnuva başarıları ve`)
};

const hi_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतियोगी उपलब्धियाँ और`)
};

const id_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasi kompetitif &`)
};

const ms_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian kejohanan &`)
};

const cs_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutěžní úspěchy a`)
};

const el_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αγωνιστικές επιτυχίες &`)
};

const he_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הישגים תחרותיים &`)
};

const af_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompetisieprestasies en`)
};

const hu_about_playing_title_lead = /** @type {(inputs: About_Playing_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versenyeredmények és`)
};

/**
* | output |
* | --- |
* | "Competitive achievements &" |
*
* @param {About_Playing_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_playing_title_lead = /** @type {((inputs?: About_Playing_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Playing_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_playing_title_lead(inputs)
	if (locale === "de") return de_about_playing_title_lead(inputs)
	if (locale === "zh") return zh_about_playing_title_lead(inputs)
	if (locale === "ar") return ar_about_playing_title_lead(inputs)
	if (locale === "fr") return fr_about_playing_title_lead(inputs)
	if (locale === "vi") return vi_about_playing_title_lead(inputs)
	if (locale === "sw") return sw_about_playing_title_lead(inputs)
	if (locale === "th") return th_about_playing_title_lead(inputs)
	if (locale === "bs") return bs_about_playing_title_lead(inputs)
	if (locale === "ja") return ja_about_playing_title_lead(inputs)
	if (locale === "ko") return ko_about_playing_title_lead(inputs)
	if (locale === "pt") return pt_about_playing_title_lead(inputs)
	if (locale === "it") return it_about_playing_title_lead(inputs)
	if (locale === "sv") return sv_about_playing_title_lead(inputs)
	if (locale === "nl") return nl_about_playing_title_lead(inputs)
	if (locale === "da") return da_about_playing_title_lead(inputs)
	if (locale === "nb") return nb_about_playing_title_lead(inputs)
	if (locale === "fi") return fi_about_playing_title_lead(inputs)
	if (locale === "pl") return pl_about_playing_title_lead(inputs)
	if (locale === "ru") return ru_about_playing_title_lead(inputs)
	if (locale === "tr") return tr_about_playing_title_lead(inputs)
	if (locale === "hi") return hi_about_playing_title_lead(inputs)
	if (locale === "id") return id_about_playing_title_lead(inputs)
	if (locale === "ms") return ms_about_playing_title_lead(inputs)
	if (locale === "cs") return cs_about_playing_title_lead(inputs)
	if (locale === "el") return el_about_playing_title_lead(inputs)
	if (locale === "he") return he_about_playing_title_lead(inputs)
	if (locale === "af") return af_about_playing_title_lead(inputs)
	if (locale === "hu") return hu_about_playing_title_lead(inputs)
	return en_about_playing_title_lead(inputs)
});